import { render, staticRenderFns } from "./MyQuotationsIssued.vue?vue&type=template&id=513c7021&scoped=true&"
import script from "./MyQuotationsIssued.vue?vue&type=script&lang=js&"
export * from "./MyQuotationsIssued.vue?vue&type=script&lang=js&"
import style0 from "./MyQuotationsIssued.vue?vue&type=style&index=0&id=513c7021&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c7021",
  null
  
)

component.options.__file = "MyQuotationsIssued.vue"
export default component.exports